import React from 'react';
import styles from '../Styles/DiagnosticAPage.module.css';
import imgInitial from './../../../assets/images/diagnosticos/Inicio-Madurez-digital.webp';
import '../../../App.css';
import { useDiagnostico } from '../../../context/DiagnosticoContext/DiagnosticoHook';

const Introduction = (props) => {
  const { changeStateShowIntroductionFn, changeStateShowIntermediateTextFn } =
    useDiagnostico();
  const { setIndiceGrupoActual } = props;
  return (
    <div className={styles.containerInitial}>
      <div className={styles.containerHeaderInitial}>
        <div className={styles.containerTitle}>
          <h2>Madurez digital</h2>
        </div>
        <div className={styles.containerImg}>
          <img src={imgInitial} />
        </div>
      </div>
      <p className={styles.description}>
        ¡Te damos la bienvenida a nuestra sesión de madurez digital!
      </p>
      <p className={styles.description}>
        Este puede ser el comienzo para superar los desafíos y aprovechar las
        oportunidades de la era digital.
        <br />
        <br />
        Vas a poder evaluar tu posición actual, identificar oportunidades de
        crecimiento y crear un plan de acción que acelere la transformación
        digital de tu organización. Das el primer paso para acelerar tu negocio
        y entre todos ayudamos al desarrollo económico empresarial del país y de
        Latinoamérica.
      </p>
      <br />
      <button
        className={'btn btn-primary btn-comenzar'}
        onClick={() => {
          changeStateShowIntroductionFn(false);
          changeStateShowIntermediateTextFn(true);
          setIndiceGrupoActual(0);
        }}
      >
        Continuar <span className="material-icons">arrow_forward</span>
      </button>
    </div>
  );
};

export default Introduction;
